import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";

interface RejectedWorkOrder {
  error?: { message: string };
  [key: string]: any;
}

interface RejectedWorkOrdersProps {
  rejectedOrders: RejectedWorkOrder[];
  open: boolean;
  onClose: () => void;
}

// Use a descriptive constant name for clarity
const NUMBER_PER_PAGE = 1;

const RejectedWorkOrderDialogReport: React.FC<RejectedWorkOrdersProps> = ({
  rejectedOrders,
  open,
  onClose,
}) => {
  const [page, setPage] = useState<number>(0);

  const totalPages = Math.ceil(rejectedOrders.length / NUMBER_PER_PAGE);

  const handlePrev = () => setPage((prev) => Math.max(prev - 1, 0));
  const handleNext = () => setPage((prev) => Math.min(prev + 1, totalPages - 1));

  React.useEffect(() => {
    if (open) setPage(0); // Reset to first page when dialog opens
  }, [open]);

  const currentOrder =
    rejectedOrders.slice(page * NUMBER_PER_PAGE, (page + 1) * NUMBER_PER_PAGE)[0];

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Rejected Work Orders
        <IconButton
          aria-label="close"
          onClick={onClose}
          size="large"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        {currentOrder ? (
          <div style={{ border: "1px solid #ccc", padding: 16, marginBottom: 16 }}>
            <div>
              <strong>Order ID:</strong> {currentOrder.id}
            </div>
            <div style={{ color: "red", marginTop: 8 }}>
              <strong>Error:</strong>{" "}
              {currentOrder.error && currentOrder.error.message
                ? currentOrder.error.message
                : "An unknown error was returned from Aim"}
            </div>
            {/* Render other properties if needed */}
          </div>
        ) : (
          <div>No rejected work orders.</div>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <IconButton onClick={handlePrev} disabled={page === 0} aria-label="previous" size="large">
          <ArrowBackIosNewIcon />
        </IconButton>
        <span style={{ margin: "0 8px" }}>
          Page {page + 1} of {totalPages}
        </span>
        <IconButton onClick={handleNext} disabled={page >= totalPages - 1} aria-label="next" size="large">
          <ArrowForwardIosIcon />
        </IconButton>
      </DialogActions>
    </Dialog>
  );
};

export default RejectedWorkOrderDialogReport;